import { decode, length } from '@protobufjs/base64';
import { inflate } from 'pako';
import { Session } from './proto';
export var decodeBase64 = function decodeBase64(value) {
  var zipped = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var arrayLength = Math.floor(length(value));
  var bytes = new Uint8Array(arrayLength);
  decode(value, bytes, 0);

  if (zipped) {
    bytes = inflate(bytes);
  }

  return bytes;
};
export var parseToken = function parseToken(token) {
  return JSON.parse(atob(token.split('.')[1]));
};
export var deserializeSession = function deserializeSession(parsedToken) {
  var sess = parsedToken.sess,
      zipped = parsedToken.zipped;
  var bytes = decodeBase64(sess, zipped);
  return Session.fromBinary(bytes);
};